<div class="row">
    <div class="col-lg-12">
        <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" (activeIdChange)="tabChanged()" class="nav-tabs" style="margin-bottom: 15px">
            <li [ngbNavItem]="0" [destroyOnHide]="false">
                <a ngbNavLink>My To-Dos</a>
                <ng-template ngbNavContent>
                    <div class="row action-toolbar">
                        <div class="col-12">
                            <form class="form-inline">
                                <action-toolbar-count [grid]="grid"></action-toolbar-count>
                                <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                                <action-toolbar-buttons
                                    [grid]="grid"
                                    [canEdit]="true"
                                    [showAdd]="true"
                                    [showEdit]="false"
                                    [showDelete]="false"
                                ></action-toolbar-buttons>
                                <span class="text-muted" style="margin-left: 10px; line-height: 30px">
                                    {{ completedInPast7Days }} completed in past 7 days
                                </span>
                            </form>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <wj-flex-grid
                                id="mainGrid"
                                #mainGrid
                                style="height: 225px"
                                (initialized)="grid.initialize(mainGrid)"
                                (destroy)="grid.destroy()"
                                [itemsSource]="grid.view"
                                [itemFormatter]="gridItemFormatter"
                                (beginningEdit)="cellBeginningEdit(mainGrid, $event)"
                                (cellEditEnded)="cellEditEnded(mainGrid, $event)"
                            >
                                <wj-flex-grid-filter></wj-flex-grid-filter>
                                <wj-flex-grid-column [header]="' '" [binding]="'isHot'" [width]="50" [isReadOnly]="true">
                                    <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                        <div style="text-align: center; cursor: pointer" (click)="toggleHot(cell)">
                                            <fa-icon class="d-none d-sm-inline-block" [icon]="faFire"></fa-icon>
                                        </div>
                                    </ng-template>
                                </wj-flex-grid-column>
                                <wj-flex-grid-column [header]="' '" [binding]="'createdByDisplayName'" [width]="40" [isReadOnly]="true">
                                    <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                        @if (cell.item?.type === 'toDo') {
                                            <div
                                                class="text-muted"
                                                style="text-align: center"
                                                (mouseenter)="showCreatorTooltip($event, cell.item)"
                                                (mouseleave)="hideCreatorTooltip()"
                                            >
                                                <fa-icon class="d-none d-sm-inline-block" [icon]="faUser"></fa-icon>
                                            </div>
                                        }
                                    </ng-template>
                                </wj-flex-grid-column>
                                <wj-flex-grid-column
                                    [header]="'Due'"
                                    [binding]="'dueDate'"
                                    [width]="105"
                                    [isReadOnly]="true"
                                ></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'Source'" [binding]="'source'" [width]="200" [isReadOnly]="true">
                                    <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                        @if (
                                            (cell.item?.type === 'pendingChangeOrder' || cell.item?.type === 'pcoPmReadyForApproval') &&
                                            cell.item?.id
                                        ) {
                                            <a [routerLink]="['/field-tools/pending-change-orders']" [queryParams]="{ openPcoId: cell.item.id }">{{
                                                cell.item.source
                                            }}</a>
                                        } @else if (cell.item?.type === 'punchListItem' && cell.item?.id) {
                                            <a
                                                [routerLink]="['/field-tools/punch-list']"
                                                [queryParams]="{ openPunchListItemId: cell.item.id, jobId: cell.item.job }"
                                            >{{ cell.item.source }}</a>
                                        } @else if (
                                            cell.item?.type === 'jhaSuperintendent' &&
                                            cell.item?.id &&
                                            cell.item?.openJhaItemId
                                        ) {
                                            <a
                                                [routerLink]="['/safety/job-hazard-analysis']"
                                                [queryParams]="{ openJhaId: cell.item.id, openJhaItemId: cell.item.openJhaItemId }"
                                                >{{ cell.item.source }}</a>
                                        } @else {
                                            <span>{{ cell.item?.source }}</span>
                                        }
                                    </ng-template>
                                </wj-flex-grid-column>
                                <wj-flex-grid-column
                                    [header]="'To-Do'"
                                    [binding]="'displayName'"
                                    [width]="'*'"
                                    [isReadOnly]="true"
                                ></wj-flex-grid-column>
                                <wj-flex-grid-column
                                    [header]="'Done'"
                                    [binding]="'doneDate'"
                                    [width]="125"
                                    [editor]="inputDate"
                                    [isRequired]="false"
                                ></wj-flex-grid-column>
                            </wj-flex-grid>
                            <wj-input-date #inputDate [isRequired]="false"></wj-input-date>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 5px">
                        <div class="col-lg-12" style="height: 225px">
                            @if (grid.selectedItem) {
                                <div class="h-100 d-flex flex-column">
                                    <h6 style="flex-shrink: 0">{{ grid.selectedItem?.name }}</h6>
                                    <div class="flex-grow-1" style="min-height: 0">
                                        <quill-view
                                            style="display: block; height: 188px"
                                            [content]="grid.selectedItem?.details ?? 'No Details'"
                                            theme="snow"
                                        ></quill-view>
                                    </div>
                                </div>
                            } @else {
                                <h6 style="flex-shrink: 0">Select To-Do above</h6>

                                <div
                                    class="d-flex align-items-center justify-content-center h-100"
                                    style="border: 1px solid lightgray; max-height: 189px"
                                >
                                    <div class="text-center">
                                        <div class="mb-3">
                                            <i class="fas fa-hand-pointer fa-3x text-muted"></i>
                                        </div>
                                        <h5 class="text-muted mb-2">No To-Do Selected</h5>
                                        <p class="text-muted mb-0">Select a to-do from the list to view its details</p>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </ng-template>
            </li>
            <li [ngbNavItem]="1" [destroyOnHide]="false">
                <a ngbNavLink>To-Dos I Assigned (Beta)</a>
                <ng-template ngbNavContent>
                    <div class="row action-toolbar">
                        <div class="col-12">
                            <form class="form-inline">
                                <action-toolbar-count [grid]="assignedGrid"></action-toolbar-count>
                                <action-toolbar-search name="searchAssigned" [(ngModel)]="assignedGrid.filter"></action-toolbar-search>
                                <action-toolbar-buttons
                                    [grid]="assignedGrid"
                                    [canEdit]="true"
                                    [showAdd]="true"
                                    [showEdit]="false"
                                    [showDelete]="false"
                                ></action-toolbar-buttons>
                                <span class="text-muted" style="margin-left: 10px; line-height: 30px">
                                    {{ completedInPast7DaysAssigned }} completed in past 7 days
                                </span>
                            </form>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <wj-flex-grid
                                id="assignedGrid"
                                #assignedGridElement
                                style="height: 225px"
                                (initialized)="assignedGrid.initialize(assignedGridElement)"
                                (destroy)="assignedGrid.destroy()"
                                [itemsSource]="assignedGrid.view"
                                [itemFormatter]="assignedGridItemFormatter"
                                (cellEditEnded)="assignedCellEditEnded(assignedGridElement, $event)"
                            >
                                <wj-flex-grid-filter></wj-flex-grid-filter>
                                <wj-flex-grid-column [header]="' '" [binding]="'isHot'" [width]="50" [isReadOnly]="true">
                                    <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                        <div style="text-align: center; cursor: pointer" (click)="toggleHotAssigned(cell)">
                                            <fa-icon class="d-none d-sm-inline-block" [icon]="faFire"></fa-icon>
                                        </div>
                                    </ng-template>
                                </wj-flex-grid-column>
                                <wj-flex-grid-column
                                    [header]="'Due'"
                                    [binding]="'dueDate'"
                                    [width]="105"
                                    [isReadOnly]="true"
                                ></wj-flex-grid-column>
                                <wj-flex-grid-column
                                    [header]="'Assigned To'"
                                    [binding]="'assignedToDisplayName'"
                                    [width]="150"
                                    [isReadOnly]="true"
                                ></wj-flex-grid-column>
                                <wj-flex-grid-column
                                    [header]="'Source'"
                                    [binding]="'source'"
                                    [width]="200"
                                    [isReadOnly]="true"
                                ></wj-flex-grid-column>
                                <wj-flex-grid-column
                                    [header]="'To-Do'"
                                    [binding]="'displayName'"
                                    [width]="'*'"
                                    [isReadOnly]="true"
                                ></wj-flex-grid-column>
                                <wj-flex-grid-column
                                    [header]="'Done'"
                                    [binding]="'doneDate'"
                                    [width]="125"
                                    [editor]="inputDateAssigned"
                                    [isRequired]="false"
                                ></wj-flex-grid-column>
                            </wj-flex-grid>
                            <wj-input-date #inputDateAssigned [isRequired]="false"></wj-input-date>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 5px">
                        <div class="col-lg-12" style="height: 225px">
                            @if (assignedGrid.selectedItem) {
                                <div class="h-100 d-flex flex-column">
                                    <h6 style="flex-shrink: 0">{{ assignedGrid.selectedItem?.name }}</h6>
                                    <div class="flex-grow-1" style="min-height: 0">
                                        <quill-view
                                            style="display: block; height: 188px"
                                            [content]="assignedGrid.selectedItem?.details ?? 'No Details'"
                                            theme="snow"
                                        ></quill-view>
                                    </div>
                                </div>
                            } @else {
                                <h6 style="flex-shrink: 0">Select To-Do above</h6>

                                <div
                                    class="d-flex align-items-center justify-content-center h-100"
                                    style="border: 1px solid lightgray; max-height: 189px"
                                >
                                    <div class="text-center">
                                        <div class="mb-3">
                                            <i class="fas fa-hand-pointer fa-3x text-muted"></i>
                                        </div>
                                        <h5 class="text-muted mb-2">No To-Do Selected</h5>
                                        <p class="text-muted mb-0">Select a to-do from the list to view its details</p>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </ng-template>
            </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>
</div>
